// 数据字典相关 API
import apiFactory from '@centit/api-core'

const api = apiFactory.create('admin', {useFormData: true})
const optId = localStorage.getItem('$currentApp')
/**
 * 数据字典列表查询
 * @param params
 * @param sort
 * @param page
 * @param useApp
 * @returns {*|PromiseLike<T | never>|Promise<T | never>}
 */
export function queryDictionary({ params = {}, sort = {}, page = {} } = {}, useApp) {
  if (useApp) {
    params.optId = optId
  }

  return api.get('/system/dictionary', {
    params: {
      ...params,
      ...sort,
      ...page,
    },
  })
}

/**
 * 判断数据字典编码唯一
 * @param catalogCode
 * @returns {*}
 */
export function checkDictionaryCodeUnique(catalogCode) {
  if (!catalogCode) return true

  return api.get(`/system/dictionary/notexists/${catalogCode}`)
}

/**
 * 获取数据字典信息
 * @param id
 * @returns {*|PromiseLike<T | never>|Promise<T | never>}
 */
export function getDictionary(id) {
  return api.get(`/system/dictionary/${id}`)
}

/**
 * 新增数据字典
 * @param dic
 * @param useApp
 * @returns {*|PromiseLike<T | never>|Promise<T | never>}
 */
export function addDictionary(dic, useApp) {
  if (useApp) {
    dic.optId = optId
  }
  return api.post('/system/dictionary', dic)
}

/**
 * 修改数据字典
 * @param id
 * @param dic
 * @returns {Promise<T | never>}
 */
export function modifyDictionary(id, dic) {
  return api.put(`/system/dictionary/update/${id}`, dic)
}

/**
 * 修改数据字典明细
 * @param id
 * @param dic
 * @returns {Promise<T | never>}
 */
export function modifyDictionaryDetails(id, dic) {
  return api.put(`/system/dictionary/update/${id}`, dic)
}

/**
 * 删除数据字典
 * @param id
 * @returns {*|PromiseLike<T | never>|Promise<T | never>}
 */
export function removeDictionary(id) {
  return api.delete(`/system/dictionary/${id}`)
}
